import ChecklistItem from "./components/ChecklistItem";
import { useTranslation } from "react-i18next";
import usePasswordPolicy from "./hooks/usePasswordPolicy";
import { useWatch } from "react-hook-form";

const passwordConfig = {
  minLength: 8,
  specialChars: "^$*.[]{}()?-\"!@#%&/,><':;|_~`+=",
};

export default function PasswordPolicyChecklist() {
  const context = useWatch<{
    password: string;
  }>();

  const { password } = context;
  const { t } = useTranslation();
  const policy = usePasswordPolicy(passwordConfig);

  return (
    <section className="text-slate-500 text-sm rounded bg-slate-50 p-4">
      <h3 className="mb-2 font-medium">{t("passwordPolicy.title")}</h3>
      <ul>
        {policy.keys.map((key) => (
          <ChecklistItem key={key} passed={policy.check(key, password ?? "")}>
            {t(`passwordPolicy.${key}`, passwordConfig)}
          </ChecklistItem>
        ))}
      </ul>
    </section>
  );
}
